/**
 * API суурь хаяг.
 * - Production: AWS API Gateway (api.dma.mn одоогоор 443 дээр холбогдохгүй)
 * - Локал: php artisan serve
 */
const REMOTE_PRODUCTION_API =
  'https://e28vgwsnai.execute-api.ap-southeast-1.amazonaws.com/production/api'

const BASE_SERVER_PATH = (typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8000/api'
  : REMOTE_PRODUCTION_API

export default {
  BASE_SERVER_PATH
}
